import { createSlice } from '@reduxjs/toolkit'

import { compartmentsAdapter } from './compartmentsAdapters'
import { saveCompartment } from './thunks/saveCompartment'
import { toggleCompartmentStatus } from './thunks/toggleCompartmentStatus'

export const initialCompartmentState = compartmentsAdapter.getInitialState()

export const compartmentsSlice = createSlice({
  name: 'compartments',
  initialState: initialCompartmentState,
  reducers: {
    upsertMultipleCompartments: (state, action) => {
      compartmentsAdapter.upsertMany(state, action.payload)
    },
  },
  extraReducers: builder => {
    builder
      .addCase(saveCompartment.fulfilled, (state, action) => {
        compartmentsAdapter.upsertOne(state, action.payload)
      })
      .addCase(toggleCompartmentStatus.fulfilled, (state, action) => {
        const id = action.payload

        if (!id) return

        const compartment = state.entities[id]

        if (compartment) {
          compartment.isActive = !compartment.isActive
        }
      })
  },
})

export const { upsertMultipleCompartments } = compartmentsSlice.actions